import React from 'react'
import { Box, Card, CardMedia, Paper, Stack, Typography } from '@mui/material'
import { useGlobalState } from 'state'
import { Legend, ObservatoryType } from 'common/types'
import { styled } from '@mui/material/styles'
import { MenuLegends, RainObservatoryLegend, StageObservatoryLegend, SuijinObservatoryLegend } from 'common/consts'
import { LegendRoadRegulation } from './LegendRoadRegulation'
import { green, grey, purple, red } from '@mui/material/colors'


type ObservatoryIconProps = {
  color: string
  strokeColor?: string
  strokeWidth?: number
}

const RainIcon = ({ color, strokeColor = grey[600], strokeWidth = 2 }: ObservatoryIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" shapeRendering="geometricPrecision">
      <circle
        cx="24"
        cy="24"
        r="20"
        fill={color}
        opacity="1"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

const StageIcon = ({ color, strokeColor = grey[600], strokeWidth = 2 }: ObservatoryIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" shapeRendering="geometricPrecision">
      <path
        d="M2 43L24.055 5L46 43L2 43Z"
        fill={color}
        fillRule="nonzero"
        opacity="1"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

const SuijinIcon = ({ color, strokeColor = grey[600], strokeWidth = 2 }: ObservatoryIconProps) => {
  return (
    <svg height="48.0pt" version="1.1" viewBox="0 0 48 48" width="48.0pt" xmlns="http://www.w3.org/2000/svg">
      <g opacity="1">
        <path
          d="M24 2C11.856 2 2 11.856 2 24C2 36.144 11.856 46 24 46C36.144 46 46 36.144 46 24C46 11.856 36.144 2 24 2Z"
          fill={color}
          fillRule="nonzero"
          opacity="1"
          stroke={strokeColor}
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
        <path
          d="M14.096 29.312C14.288 30.624 14.416 31.232 14.704 31.968C15.312 33.536 16.24 34.752 17.52 35.616C19.056 36.64 21.616 37.28 24.24 37.28C27.664 37.28 30.192 36.48 31.888 34.848C33.2 33.536 33.904 31.68 33.904 29.408C33.904 27.008 33.072 25.248 31.248 23.904C30.096 23.104 28.56 22.496 26.032 21.952C22.48 21.152 22.224 21.088 21.52 20.8C20.048 20.16 19.344 19.232 19.344 17.888C19.344 15.808 21.232 14.4 24.016 14.4C25.776 14.4 27.184 14.944 28.016 15.936C28.56 16.576 28.784 17.12 28.976 18.208L33.552 17.664C33.168 15.968 32.784 15.008 31.984 13.952C30.416 11.84 27.664 10.72 24.016 10.72C18.512 10.72 14.928 13.6 14.928 18.048C14.928 20.192 15.76 21.952 17.392 23.232C18.544 24.128 19.824 24.64 22.224 25.184C26.64 26.208 26.832 26.24 27.792 26.752C28.784 27.296 29.392 28.384 29.392 29.696C29.392 32.096 27.472 33.536 24.272 33.536C22.192 33.536 20.528 32.864 19.6 31.648C19.024 30.912 18.832 30.272 18.704 28.832L14.096 29.312Z"
          fill="#ffffff"
          fillRule="nonzero"
          opacity="1"
          strokeWidth={0}
        />
      </g>
    </svg>
  )
}

// const getSuijinSvg = (color: string): string => {
//   const fontColor = color === SuijinStatus.FLOOD1.color ? '#000000' : '#ffffff'
//   return `<svg height="48.0pt" stroke-miterlimit="10" style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" version="1.1" viewBox="0 0 48 48" width="48.0pt" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
//   <defs/>
//   <g opacity="1">
//   <path d="M24 2C11.856 2 2 11.856 2 24C2 36.144 11.856 46 24 46C36.144 46 46 36.144 46 24C46 11.856 36.144 2 24 2Z" fill="${color}" fill-rule="nonzero" opacity="1" stroke="#393939" stroke-linecap="butt" stroke-linejoin="round" stroke-width="1"/>
//   <path d="M14.096 29.312C14.288 30.624 14.416 31.232 14.704 31.968C15.312 33.536 16.24 34.752 17.52 35.616C19.056 36.64 21.616 37.28 24.24 37.28C27.664 37.28 30.192 36.48 31.888 34.848C33.2 33.536 33.904 31.68 33.904 29.408C33.904 27.008 33.072 25.248 31.248 23.904C30.096 23.104 28.56 22.496 26.032 21.952C22.48 21.152 22.224 21.088 21.52 20.8C20.048 20.16 19.344 19.232 19.344 17.888C19.344 15.808 21.232 14.4 24.016 14.4C25.776 14.4 27.184 14.944 28.016 15.936C28.56 16.576 28.784 17.12 28.976 18.208L33.552 17.664C33.168 15.968 32.784 15.008 31.984 13.952C30.416 11.84 27.664 10.72 24.016 10.72C18.512 10.72 14.928 13.6 14.928 18.048C14.928 20.192 15.76 21.952 17.392 23.232C18.544 24.128 19.824 24.64 22.224 25.184C26.64 26.208 26.832 26.24 27.792 26.752C28.784 27.296 29.392 28.384 29.392 29.696C29.392 32.096 27.472 33.536 24.272 33.536C22.192 33.536 20.528 32.864 19.6 31.648C19.024 30.912 18.832 30.272 18.704 28.832L14.096 29.312Z" fill="${fontColor}" fill-rule="nonzero" opacity="1" stroke-width="0"/>
//   </g>
//   </svg>`
// }

const LegendTitle = ({title}: {title: string | undefined}) => {
  if (!title) return <></>
  return (
    <Typography sx={{
      fontSize: 11,
      lineHeight: 1.2,
      textAlign: 'right',
      fontWeight: 'bold',
      whiteSpace: 'pre-wrap',
      color: grey[800],
      textShadow: '1px 1px 0 #ffffff, -1px 1px 0 #ffffff, 1px -1px 0 #ffffff, -1px -1px 0 #ffffff',
    }}>
      {title}
    </Typography>
  )
}

const SpotLegendText = styled(Typography)(() => ({
  fontSize: 11,
  color: grey[700],
  textShadow: '1px 1px 1px rgba(240, 240, 240, 1), 1px 1px 2px rgba(240, 240, 240, 0.8), -1px 0px 1px rgba(240, 240, 240, 0.6)',
  fontWeight: 'bold'
}))

export const LegendPanel = ({legend, obsType}: {legend: Legend, obsType?: ObservatoryType}) => {
  const iconSize = 14
  return (
    <Stack alignItems={'flex-end'}>
      <LegendTitle title={legend.title} />
      { legend.colors && (
        <Stack component={Card} bgcolor={'rgba(250, 250, 250, 0.95)'} sx={{ pointerEvents: 'painted'}}>
          <Stack py={'2px'} px={'6px'} spacing={0}>
            { legend.colors.map((c, index) => {
              return (
                <Stack direction={'row'} spacing={1} alignItems={'center'} key={index}>
                  { obsType === ObservatoryType.Rain && <Box width={iconSize} height={iconSize} display={'flex'} alignItems={'center'} justifyContent={'center'}><RainIcon color={c.color} strokeColor={grey[800]} strokeWidth={1} /></Box> }
                  { obsType === ObservatoryType.Stage && <Box width={iconSize} height={iconSize} display={'flex'} alignItems={'center'} justifyContent={'center'}><StageIcon color={c.color} strokeColor={grey[600]} strokeWidth={2} /></Box> }
                  { obsType === ObservatoryType.Suijin && <Box width={iconSize} height={iconSize} display={'flex'} alignItems={'center'} justifyContent={'center'}><SuijinIcon color={c.color} strokeColor={grey[600]} strokeWidth={2} /></Box> }
                  { obsType === undefined && <Box width={iconSize} height={iconSize} bgcolor={c.color} border={'1px solid ' + grey[400]}></Box> }
                  <Typography variant='caption' fontSize={11} whiteSpace={'nowrap'}>{c.value}</Typography>
                </Stack>
              )
            }) }
          </Stack>
        </Stack>
      )}
      { legend.image !== undefined && (
        <Card sx={{maxWidth: 40, maxHeight: 30}}>
          <CardMedia component="img" src={legend.image} />
        </Card>
      )}
    </Stack>
  )
}

export const LegendControl = () => {
  const state = useGlobalState()
  const [menuLegends, setMenuLegends] = React.useState<Legend[]>([])

  React.useEffect(() => {
    setMenuLegends(MenuLegends[state.app.menu])
  }, [state.app.menu])

  const isRiverFloods = React.useMemo(() => {
    return state.app.menu === 'river-floods'
  }, [state.app.menu])

  return (
    <Stack direction={'column'} alignItems={'flex-end'} spacing={1}>
      <Stack direction={'row'} spacing={1}>
        { state.app.observatoryTypes.includes(ObservatoryType.Suijin) && <LegendPanel legend={SuijinObservatoryLegend} obsType={ObservatoryType.Suijin}  /> }
        { state.app.observatoryTypes.includes(ObservatoryType.Rain) && <LegendPanel legend={RainObservatoryLegend} obsType={ObservatoryType.Rain}  /> }
        { state.app.observatoryTypes.includes(ObservatoryType.Stage) && <LegendPanel legend={StageObservatoryLegend} obsType={ObservatoryType.Stage}  /> }
      </Stack>
      <Stack direction={'row'} spacing={1}>
        <Stack direction={'row'} spacing={1}>
          { menuLegends.map((legend: Legend, index: number) => <LegendPanel legend={legend} key={index} />) }
        </Stack>
        <LegendRoadRegulation />
      </Stack>
      { isRiverFloods && (
        <Paper elevation={1} sx={{backgroundColor: 'rgba(240,240,240,0.8)', p: 1, m: 0, width: 100}}>
          <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <Box width={20} height={5} borderTop={`5px solid ${red[500]}`} />
            <SpotLegendText>高齢者避難</SpotLegendText>
          </Stack>
          <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <Box width={20} height={10} borderTop={`5px solid ${red[500]}`} borderBottom={`5px solid ${purple[500]}`} />
            <SpotLegendText>避難指示</SpotLegendText>
          </Stack>
          <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <Box width={20} height={10} borderTop={`5px solid ${red[500]}`} borderBottom={`5px solid ${grey[900]}`} />
            <SpotLegendText>緊急避難</SpotLegendText>
          </Stack>
        </Paper>
      )}
      <Paper elevation={1} sx={{backgroundColor: 'rgba(240,240,240,0.8)', p: 1, m: 0, width: 100}}>
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <Box width={20} height={20} border={`3px solid ${green[500]}`} />
          <SpotLegendText>巴川流域</SpotLegendText>
        </Stack>
      </Paper>
    </Stack>
  )
}
